module.exports = __webpack_public_path__ + "img/ba1.e54f1e73.jpg";